import React, { useEffect, useState } from "react";
import SubHeader from "../../menu/SubHeader";
import { ReactComponent as FatigueAssessmentIcon } from "assets/icons/fatigue-assessment-filled.svg";
import './DrivingExemptions.css';
import { DrivingExemptionSidebar } from "./DrivingExemptionSidebar";
import { DrivingExemptionPageSelector } from "./DrivingExemptionPageSelector";
import useSelector from "../../../hooks/useSelector";
import { ISelectOption } from "../forms/util";

interface DrivingExemptionPageProps {
    selectedPage: ISelectOption,
    children?: React.ReactNode
}

const DrivingExemptionPage = (props: DrivingExemptionPageProps) => {
    const [currentSelection] = useState(props.selectedPage);
    const gnhFormsFeatureToggle = useSelector(state => state.gnhFormsFeatureToggle);
    const [gnhFormsFeatureEnabled, setGNHFormsFeatureEnabled] = useState(false);

    useEffect(() => {
        setGNHFormsFeatureEnabled(gnhFormsFeatureToggle);
    }, [gnhFormsFeatureToggle]);

    return (
        <>
            {gnhFormsFeatureEnabled &&
                <div className="driving-exemptions">
                    <div className="exemption-header-bg"></div>
                    <div className="narrow-container">
                        <SubHeader />
                        <div className="driving-exemptions-page">
                            <div className="driving-exemptions-heading de-narrow">
                                <FatigueAssessmentIcon />
                                Driving Exemption
                            </div>
                            <DrivingExemptionPageSelector selectedPage={currentSelection} />

                            <div className="row">
                                <div className="de-wide col-3">
                                    <DrivingExemptionSidebar selectedPage={currentSelection} />
                                </div>
                                <div className="col">
                                    <React.Fragment>{props.children}</React.Fragment>
                                </div>
                            </div>

                            <div className="driving-exemptions-footer"></div>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}

export default DrivingExemptionPage;